export default __webpack_public_path__ + "static/media/kitchen3-after3-1920w.3d00e19b.avif";